import React, {Component} from 'react';
import {BodyContainer} from "../Container/Container";
import {CardTitle, P2} from "../Kit/Kit";
import styled from 'styled-components';

const InnerContainer = styled.div`
  @media(min-width: 992px){
    padding: 0 130px;
  }
  
  @media(min-width: 1200px){
    padding: 0 220px;
  }
`;

const Title = CardTitle.extend`
  line-height: 1.25;
  
   @media(min-width: 992px){
    padding: 0 50px;
  }
`;

const GroupContainer = styled.div`
  margin-top: 30px;
  display: flex;  
  justify-content: space-around;
  
  @media(min-width: 1200px){
    margin-top: 40px;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  p {
    max-width: 135px;
    cursor: pointer;
  }
  
  img{
    width: 80px;
    height: 80px;
    cursor: pointer;
    
    :hover {
      filter: opacity(.6);
    }
    
    @media(min-width: 992px) {
      width: 100px;
      height: 100px;
    }
    
    @media(min-width: 1200px) {
      width: 135px;
      height: 135px;
    }
  }
`;

class QualitySection extends Component {
    render() {
        const {onClick, subheader, data} = this.props;
        return (
          <BodyContainer>
              <Title>{subheader}</Title>
              <InnerContainer>
                  <GroupContainer>
                      {data.map(i => {
                          return (
                            <CardContainer key={i.title}>
                                <img
                                  src={i.image.source_url}
                                  alt={i.image.alt_text}
                                  onClick={() => onClick(i.title)}
                                />
                                <P2
                                  onClick={() => onClick(i.title)}
                                >{i.title}</P2>
                            </CardContainer>
                          )
                      })}
                  </GroupContainer>
              </InnerContainer>
          </BodyContainer>
        );
    }
}

export default QualitySection;


// WEBPACK FOOTER //
// ./src/components/ProductInfo/QualitySection.js